module.exports = __webpack_public_path__ + "img/subscribe-banner.34bff854.jpg";